import { render, staticRenderFns } from "./conges-form.vue?vue&type=template&id=5b0c1783&scoped=true"
import script from "./conges-form.vue?vue&type=script&lang=js"
export * from "./conges-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0c1783",
  null
  
)

export default component.exports